// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconSymbolsHelp_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.96856 3.5C9.64255 3.5 11 4.68411 11 6.14494 11 7.11706 10.3988 7.96624 9.50277 8.42536H9.50454C9.23437 8.55636 9.02621 8.77222 8.92771 9.03159H8.93107V9.5H7.09924V9.03159H7.09764C7.12865 8.82069 7.18782 8.61799 7.27197 8.42536 7.52106 7.86017 7.98486 7.38696 8.57782 7.08532 8.95304 6.8995 9.20727 6.54754 9.20727 6.14494 9.20727 5.54878 8.65152 5.06395 7.96839 5.06395 7.28579 5.06395 6.72951 5.54878 6.72951 6.14494L4.99995 5.60621C5.28525 4.40375 6.50643 3.5 7.96856 3.5ZM6.99995 10.5H8.99995V12.5H6.99995V10.5Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" class="svg-bg"/>
  <path d="M15 10.1449C15 8.68411 13.6425 7.5 11.9686 7.5 10.5064 7.5 9.28525 8.40375 8.99995 9.60621L10.7295 10.1449C10.7295 9.54878 11.2858 9.06395 11.9684 9.06395 12.6515 9.06395 13.2073 9.54878 13.2073 10.1449 13.2073 10.5475 12.953 10.8995 12.5778 11.0853 11.9849 11.387 11.5211 11.8602 11.272 12.4254 11.1878 12.618 11.1286 12.8207 11.0976 13.0316H11.0992V13.5H12.9311V13.0316H12.9277C13.0262 12.7722 13.2344 12.5564 13.5045 12.4254H13.5028C14.3988 11.9662 15 11.1171 15 10.1449ZM13 14.5H11V16.5H13V14.5Z" class="svg-bg"/>
</svg>
`;
/**
 * IconSymbolsHelp is a generated icon component.
 */
let IconSymbolsHelp = IconSymbolsHelp_1 = class IconSymbolsHelp extends IconBaseElement {
    render() {
        return html `${IconSymbolsHelp_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconSymbolsHelp.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconSymbolsHelp = IconSymbolsHelp_1 = __decorate([
    customElement('zui-icon-symbols-help')
], IconSymbolsHelp);
export { IconSymbolsHelp };
